/**
 * SignInModal - displays a modal with callback for signing in
 */
/** @jsxImportSource @emotion/react */
import React, { useState } from 'react';
import Modal from '../../components/book/steps/components/Modal';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { InputContainerFormField, isEmail } from '../../helpers/final-form-input-components'

import { Form, Field } from 'react-final-form';
import { FORM_ERROR } from 'final-form';

import {
  FormInput,
  Error,
  required
} from '../../helpers/final-form-input-components';

import { signIn, resetPasswordEmail } from '../../services/Authenticator';

import Button from '../../components/Button'
import SignUpFormError from './Error';

import { gsColors } from '../../styles/Variables';
import { useUserContext } from '../UserContext';

const SignInDiv = styled.div`
  padding: 0 25px 35px;

  h1 {
    color: ${gsColors.mineShaft};
    font-size: 18px;
    font-weight: bold;
    line-height: 1.39;
    letter-spacing: -0.43px;
    margin: 6px 0 8px;
  }

  label {
    // margin-top: 25px;
  }

  form {
    margin: 0;

    div {
      margin-top: 24px;
    }
  }

  .form-control {
    border: 0;
    border-bottom: 1px solid ${gsColors.black};
    font-family: Brown, sans-serif;
    font-size: 16px;
    line-height: 20px;
    padding: 10px 0;
    width: 100%;

    ::placeholder {
      color: ${gsColors.paleSlate};
    }

    &:focus {
      outline: 0;
    }
  }

  .invalid-feedback {
    color: ${gsColors.sunsetOrange};
    font-size: 13px;
    margin-top: 10px;
    line-height: 20px;
  }
`;

const SignInModal = ({ isOpen, close, isDesktop, isReset }) => {
  const { setUser } = useUserContext();

  const [working, setWorking] = useState(false);

  const doSubmit = async ({ email, password }) => {
    if (isReset) {
      await resetPasswordEmail('POST', { email: email.toLowerCase() })
    } else {
      const user = await signIn(email, password);
      if (user) {
        setUser(user);
      }
    }

    return close();
  };

  // wraps provided onSubmit function catching any errors and returning as form errors for display
  const onSubmitWithErrorHandling = values => {
    setWorking(true);

    return doSubmit(values)
      .catch(err => ({ [FORM_ERROR]: err }))
      .finally(() => setWorking(false));
  };

  const composeValidators = (...validators) => value => {    
    return validators.find(validator => validator(value))
  }

  return (
    <Modal
      isOpen={isOpen}
      closeModal={close}
      width="500px"
      isDesktop={isDesktop}
    >
      <SignInDiv>
        <Form
          onSubmit={onSubmitWithErrorHandling}
          render={({ handleSubmit, submitError, touched, errors }) => (
            <form onSubmit={handleSubmit} noValidate>
              <h1>{isReset ? 'Reset Password' : 'Sign In'}</h1>
              <InputContainerFormField name='email' type='email' label='Email Address' {...{ touched, errors }}>
                <Field
                  name="email"
                  type="email"
                  component={FormInput}
                  placeholder="Email Address"
                  validate={composeValidators(required, isEmail)}
                  showValidState
                  control
                  className="email-address"
                />
              </InputContainerFormField>
              <Error name="email" />
              {!isReset ? (
                <>
                  <InputContainerFormField name='password' type='password' label='Password' {...{ touched, errors }}>
                    <Field
                      name="password"
                      type="password"
                      component={FormInput}
                      placeholder="Create a Password"
                      validate={required}
                      showValidState
                      control
                      className="password"
                    />
                  </InputContainerFormField>
                </>
              ) : null}

              <SignUpFormError error={submitError} />
              <Button
                disabled={working}
                working={working}
                type="submit"
                fill 
                large
                hover
                margin='30px 0 0'
              >
                {isReset ? 'Reset Password' : 'Sign In'}
              </Button>
            </form>
          )}
        />
      </SignInDiv>
    </Modal>
  );
};

SignInModal.propTypes = {
  close: PropTypes.func.isRequired
};

export default SignInModal;
